//@vendor
const get = require('lodash/object/get');
//@utilities
const { APIGet } = require('utilities/APIRequestHelper');
//@constants
const actionTypes = require('../loansConstants/actionTypes');

const fetchLoanSettlementsDetails = loanSettlementId => {
    return {
        type: actionTypes.FETCH_LOAN_SETTLEMENTS_DETAILS,
        payload: {
            loanSettlementId
        }
    };
};

const fetchLoanSettlementsDetailsSuccess = (loanId, loanSettlementId, response) => {
    return {
        type: actionTypes.FETCH_LOAN_SETTLEMENTS_DETAILS_SUCCESS,
        payload: {
            loanId,
            loanSettlementId,
            details: get(response, 'detallesLiquidacion.detalleLic', []) || []
        }
    };
};

const fetchLoanSettlementsDetailsFailure = (loanId, loanSettlementId, error) => {
    return {
        type: actionTypes.FETCH_LOAN_SETTLEMENTS_DETAILS_FAILURE,
        payload: {
            loanId,
            loanSettlementId,
            error
        }
    };
};

const requestLoanSettlementsDetails = (loanId, settlementId) => (dispatch, getState) => {
    const immSettlement =  getState().loanSettlements.getIn(['byId', settlementId]);
    const immLoan =  getState().loans.getIn(['byId', loanId]);
    const immPaginationData = getState().loanSettlements.get('paginationData');

    const params = {
        query: {
            producto: immLoan.get('newProduct'),
            numeroContrato: immLoan.get('newContractNumber'),
            fechaHastaFefinpel: immSettlement.get('toDate'),
            codigoTipoAplicacion: immSettlement.get('transactionApplicationCode'),
            indicador: immSettlement.get('indicator'),
            importe: immSettlement.getIn(['amount', 'amount']),
            divisa: immSettlement.getIn(['amount', 'currency']),
            reposicionamientoIndTablaContratos: immPaginationData.get('contractTableIndicator')
        }
    };

    const config = {
        dispatch,
        endpoint: 'loanSettlementsDetails',
        params
    };

    dispatch(fetchLoanSettlementsDetails(settlementId));
    APIGet(config)
        .then(response => dispatch(fetchLoanSettlementsDetailsSuccess(loanId, settlementId, response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(fetchLoanSettlementsDetailsFailure(loanId, settlementId, response.error));
            } else {
                 throw response;
            }
        });
};

module.exports = {
    requestLoanSettlementsDetails
};
